import { render, staticRenderFns } from "./Weights.vue?vue&type=template&id=4a756fa3&scoped=true"
import script from "./Weights.vue?vue&type=script&lang=js"
export * from "./Weights.vue?vue&type=script&lang=js"
import style0 from "./Weights.vue?vue&type=style&index=0&id=4a756fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a756fa3",
  null
  
)

export default component.exports